import { render, staticRenderFns } from "./elCardShow.vue?vue&type=template&id=9984915e&scoped=true"
import script from "./elCardShow.vue?vue&type=script&lang=js"
export * from "./elCardShow.vue?vue&type=script&lang=js"
import style0 from "./elCardShow.vue?vue&type=style&index=0&id=9984915e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9984915e",
  null
  
)

export default component.exports